// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const TogetherSave = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20.946 10.085c3.258 0 5.887 2.775 5.887 6.186s-2.629 6.188-5.887 6.188H6.286c-2.834 0-5.12-2.412-5.12-5.376 0-2.87 2.145-5.224 4.855-5.37 1.001-3.449 4.037-5.88 7.546-5.88 2.903 0 5.515 1.668 6.895 4.273.16-.014.322-.02.484-.02Zm-1.337.897c-1.134-2.426-3.457-3.989-6.042-3.989-3.111 0-5.801 2.262-6.54 5.435a.577.577 0 0 1-.58.447 2.2 2.2 0 0 1-.1-.005c-2.245-.004-4.027 1.878-4.027 4.213S4.102 21.3 6.287 21.3h14.659c2.608 0 4.734-2.245 4.734-5.028 0-2.783-2.125-5.026-4.734-5.026a4.6 4.6 0 0 0-.654.047.564.564 0 0 1-.683-.31Zm-6.275 1.2v4.429l-1.245-1.252a.664.664 0 0 0-.942 0 .673.673 0 0 0 0 .948l2.381 2.396a.664.664 0 0 0 .96-.018l2.365-2.378a.673.673 0 0 0 0-.948.664.664 0 0 0-.942 0l-1.245 1.251v-4.428c0-.37-.298-.67-.666-.67-.368 0-.666.3-.666.67Z"
			fill="#fff"
		/>
	</svg>
);
export default TogetherSave;
